import { defineStyle } from '@chakra-ui/react';

import { customColors } from '../../theme/customColors';

export const MenuDividerStyles = defineStyle({
  my: 1,
  borderColor: customColors.border.primary,
  opacity: false,
});
